/**
 * @file Components/Sections/AboutDetails.jsx
 * @description Detailed about page section with expanded company history,
 * team information, and core values.
 */

import React from 'react';

const AboutDetails = () => {
  return (
    <div className="flex items-center justify-center bg-[#243185] text-white pt-28 pb-10">
      <div className="text-center">
        {/* Image above the Heading */}
        <img 
          src="./assets/icon3.png" 
          alt="Flower Icon" 
          className="mx-auto mb-4 w-32 py-5"
        />
        <h1 className="font-extrabold text-4xl py-5">About Nikaba Travels</h1>
        <div className='px-4 md:px-24 lg:px-48 text-xl'>
        <p className="mb-4">
        Nikaba Travels Pvt. Ltd. is India's inbound travel solutions provider for the Indian subcontinent.
        </p>
        <p className="mb-4">
        With the support of unparalleled products and real-time websites, we offer all-inclusive travel solutions for charters, groups, and leisure travelers as well as small businesses. Being somewhat new, we are open to fresh concepts and flexible enough to adjust to the demands of our clients. The greatest tourist spots, attractions, foods, and activities in India are featured in our guidebook.
        </p>
        <p className="mb-4">
        We provide first-rate services to our esteemed clients from all over the world through our headquarters in India and colleagues abroad. We have just begun offering an in-house Linguistic Trade Guide service in Persian, Arabic, Russian, Spanish, Italian, German, and French in order to better serve our clients who have language problems. The organization is led and run by individuals with extensive backgrounds in the hospitality sector. We serve a variety of markets, including the United States, the United Kingdom, Russia, Iran, and other major markets.
        </p>
        <p className="mb-4">
        We provide a variety of packages - elite, normal, and budget - as well as personalized services throughout India and its adjacent countries. We have extensive expertise delivering tailor-made cultural, spiritual, religious, tribal, adventure, wellness, and wildlife trips, as well as other basic packages to the Golden Triangle (Delhi, Agra, and Jaipur), Rajasthan, Kerala, Goa, Rishikesh, and other important tourist locations in India.
        </p>
        <p className="mb-4">
        Nikaba Travels handles land transportation via road, train, air ticketing (both domestic and international), and aircraft. We also provide hotel reservations, tour guides, and other services. We are a one-stop shop for all of your travel needs.
        </p>
        </div>
      </div>
    </div>
  );
}

export default AboutDetails;

